import Vue from "vue";
import VueRouter from "vue-router";
// const login = r => require.ensure([], () => r(require("../pages/login/login")), "login");


// 下面是之前h5的页面
const detail = r => require.ensure([], () => r(require('@/pages/detail/index')), 'detail')
const problem = r =>require.ensure([], () => r(require('@/pages/problem/index')), 'problem')
const general = r => require.ensure([], () => r(require('@/pages/problem/general')), 'general') // 常见问题
const installation = r => require.ensure([], () => r(require('@/pages/problem/Installation')), 'installation')
const troubleshooting = r => require.ensure([], () => r(require('@/pages/problem/Troublesshooting')), 'troubleshooting')
const post = r => require.ensure([], () => r(require('@/pages/post/detail')), 'post')
const comment = r => require.ensure([], () => r(require('@/pages/post/more')), 'comment')
const appDownload = r =>require.ensure([], () => r(require('@/pages/appDownload/index')), 'appDownload')





const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "problem",
    component: problem
  },
  {
    path: "/productList",
    name: "productList",
    component: () => import("@/pages/product/productList.vue")
  },
  {
    path: "/productItem",
    name: "productItem",
    component: () => import("@/pages/product/productItem.vue")
  },
  {
    path: "/categoryList",
    name: "categoryList",
    component: () => import("@/pages/product/categoryList.vue")
  },
  {
    path: "/imgList",
    name: "imgList",
    component: () => import("@/pages/product/imgList.vue")
  },
  {
    path: "/product/help/video",
    name: "productItem_help",
    component: () => import("@/pages/product/help/video.vue")
  },
  {
    path: "/product/help/comment",
    name: "productItem_help",
    component: () => import("@/pages/product/help/comment.vue")
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("@/pages/product/product.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/login.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/pages/login/register.vue")
  },
  // {
  //   path: "/reset",
  //   name: "reset",
  //   component: () => import("@/pages/login/reset.vue")
  // },
  // {
  //   path: "/download",
  //   name: "download",
  //   component: () => import("@/pages/login/download.vue"),
  //   meta:{
  //     title:'Signal Supervisor'
  //   }
  // },
  {
    path: "/cat",
    name: "cat",
    component: () => import("@/pages/cat/cat.vue")
  },
  {
    path: "/order",
    name: "order",
    component: () => import("@/pages/order/order.vue")
  },
  {
    path: "/orderCeshi",
    name: "order",
    component: () => import("@/pages/order/orderCeshi.vue")
  },
  {
    path: "/orderSuccess",
    name: "order",
    component: () => import("@/pages/order/orderSuccess.vue")
  },
  {
    path: "/orderFail",
    name: "order",
    component: () => import("@/pages/order/orderFail.vue")
  },
  {
    path: "/address",
    name: "address",
    component: () => import("@/pages/address/address.vue")
  },
  {
    path: "/address/add",
    name: "address",
    component: () => import("@/pages/address/addressAdd.vue")
  },
  {
    path: "/Document",
    name: "Document",
    component: () => import("@/pages/Document/index.vue")
  },

  // 下面是之前h5的页面
  {
    path: '/problem',
    name: 'problem',
    component: problem
  },
  {
    path: '/detail/:id(\\w+)?',
    name: 'detail',
    component: detail
  },
  {
    path: '/problem/general',
    name: 'general',
    component: general
  },
  {
    path: '/problem/installation',
    name: 'installation',
    component: installation
  },
  {
    path: '/problem/troubleshooting',
    name: 'troubleshooting',
    component: troubleshooting
  },
  {
    path: '/post/:id(\\w+)?',
    name: 'post',
    component: post
  },
  {
    path: '/comment/:id(\\w+)?',
    name: 'comment',
    component: comment
  },
  {
    path: '/appDownload',
    name: 'appDownload',
    component: appDownload
  },
  // {
  //   path: '*',
  //   redirect: '/problem'
  // }


];

const router = new VueRouter({
  // mode: "hash",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, form, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
  if (to.path === '/') {
    next({ path: '/problem' })
  } else {
    next()
  }
})

export default router;
